import Vue from 'vue';
import Router from 'vue-router';
import bus from '@/utils/bus.js'
import { hasAdminAuth } from '@/utils/auth'
// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//     return originalPush.call(this, location).catch(err => err)
// }
Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: '/',
            redirect: () => {
                let url = '/datalist/0/'
                try {
                    const userInfo = localStorage.getItem('userInfo')
                    const userInfoObj = JSON.parse(userInfo)
                    if (userInfoObj.user.userType === 2 && userInfoObj.folderInfos.length) {
                        url = `/datalist/${userInfoObj.folderInfos[0].levels}/`
                    }
                } catch (error) {
                    console.log(error)
                }
                return url
            }
        },
        {
            path: '/',
            component: () => import(/* webpackChunkName: "home" */ '../components/common/Home.vue'),
            meta: { title: '自述文件' },
            children: [
                {
                    path: '/home',
                    name: 'Home',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/Dashboard.vue'),
                    meta: { title: '系统首页' }
                },
                {
                    path: '/commonscheme',
                    name: 'CommonScheme',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../views/commonscheme/index.vue'),
                    meta: { title: '默认字段管理', auth: true }
                },
                {
                    path: '/managerList',
                    name: 'ManagerList',
                    component: () => import(/* webpackChunkName: "ManagerList" */ '../views/manager/ManagerList.vue'),
                    meta: { title: '管理员', auth: true }
                },
                {
                    path: '/folderManager',
                    name: 'FolderManager',
                    component: () => import(/* webpackChunkName: "FolderManager" */ '../views/folder/manager/ManagerList.vue'),
                    meta: { title: '文件夹管理员', auth: true }
                },
                {
                    path: '/datalist/:levels',
                    name: 'FolderList',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../views/folder/FolderList.vue'),
                    props: (route) => ({
                        levels: route.params.levels
                    }),
                    meta: { title: '资料列表' }
                },
                {
                    path: '/scheme',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../views/folder/scheme/SchemeManage.vue'),
                    props: (route) => ({
                        levels: route.query.levels
                    }),
                    meta: { title: '字段管理', auth: true }
                },
                {
                    // 权限页面
                    path: '/permission',
                    component: () => import(/* webpackChunkName: "permission" */ '../components/page/Permission.vue'),
                    meta: { title: '权限测试', permission: true }
                },
                {
                    path: '/404',
                    component: () => import(/* webpackChunkName: "404" */ '../components/page/404.vue'),
                    meta: { title: '404' }
                },
                {
                    path: '/403',
                    component: () => import(/* webpackChunkName: "403" */ '../components/page/403.vue'),
                    meta: { title: '403' }
                }
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: () => import(/* webpackChunkName: "login" */ '../components/page/Login.vue'),
            meta: { title: '登录' }
        },
        {
            path: '/resetPass',
            name: 'ResetPass',
            component: () => import(/* webpackChunkName: "resetPass" */ '../views/login/ResetPass.vue'),
            meta: { title: '重置密码' }
        },
        {
            path: '*',
            redirect: '/404'
        }
    ]
});

router.beforeEach((to, from, next) => {
    if (to.meta.auth) {
        if (hasAdminAuth()) {
            next()
        } else {
            next('/404')
        }
    } else {
        next()
    }
})
export default router